import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import SubCard from "ui-component/cards/SubCard";
import {
  Button,
  TextField,
  Box,
  Typography,
  Grid,
  Card,
  // CardContent,
  Tooltip,

} from "@mui/material";
import * as XLSX from "xlsx";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useEffect } from "react";
import SnackBar from "../../General/SnackBar";
import BackdropLoader from "../../General/Loader";
import { GetPurchaseOrder } from "API/PurchaseOrder/api";
import PurchaseOrderDialog from "./PurchaseOrderModal";
import { Stack } from "@mui/system";
import PaymentOrderDialog from "../PaymentOrder/PaymentOrderDialog";
import { GetAllDevice } from "API/PurchaseRequest/api";
import { GetUserRole } from "API/Misc/MakerChecker";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import { useLocation } from "react-router";
import { useRef } from "react";
import RemarksDialog from "./RemarksDialog";

function formatDate(dateString) {
  const date = new Date(dateString);

  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  return `${formattedDate}`;
}



// const GetTotalAmount = (params) => {

//   console.log("params", params);


//   const totalAmount = params.sub_total

//   console.log("totalAmount ", totalAmount);
//   return params && params.tax_type === "interstate" ?
//     (((totalAmount + parseInt(params.tax.igst) + Number.EPSILON) * 100) / 100).toFixed(2)
//     :
//     (((totalAmount + parseInt(params.tax.cgst) + parseInt(params.tax.sgst) + Number.EPSILON) * 100) / 100).toFixed(2)


// };



const ProcurementHeadPOpendingPage = () => {
  const currentDate = new Date();
  const pdfRef = useRef()

  const formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
  const [filters, setFilters] = useState({
    from_date: formattedDate,
    to_date: formattedDate,
    device: ""
  });
  const [Devices, setDevices] = useState(null)
  const [actionFilter, setActionFilter] = useState("Pending");
  const [Data, setData] = useState(null)
  const [IsLoading, setIsLoading] = useState(false)
  const [AlertMessage, setAlertMessage] = useState(null)
  const [AlertType, setAlertType] = useState("success")
  const [OpenAlert, setOpenAlert] = useState(false)
  const [Page, setPage] = useState(1)
  const [UserRole, setUserRole] = useState(null)
  const [OpenRemarks, setOpenRemarks] = useState(false)
  const [Remarks, setRemarks] = useState(null)
  const [filteredData,setFilterData] = useState(null)
  const location = useLocation()

  const handlePageChange = (page) => {
    GetPurchaseOrder(filters, setIsLoading, handleAlertOpen, setData, actionFilter, page + 1, UserRole)
    setPage(page + 1)
  }


  const handleRemarksOpen = (data) => {
    setRemarks(data)
    setOpenRemarks(true)
  }

  const handleRemarksClose = () => {
    setOpenRemarks(false)
  }

  console.log("location", location);

  // for po dialog

  const [OpenPaymentOrder, setOpenPurchaseOrder] = useState(false)

  const [Open, setOpen] = useState(false)
  const [SelectedRows, setSelectedRows] = useState(null)

  const handlePurchaseOrderOpen = (row) => {
    setOpenPurchaseOrder(true)
    setSelectedRows(row)
  }

  const handleClosePurchaseOrder = () => {
    setOpenPurchaseOrder(false)
  }

  const CalculateAmount = (params) => {
  
    let temp=params.sub_total
    console.log("temp", temp);
    
    let tax=params.tax_type==="interstate"?parseFloat(params.tax.igst):parseFloat(params.tax.cgst)+parseFloat(params.tax.sgst)
    return tax+temp
  
  
  }



  const columns = (handleViewPO) => [
    { field: "purchase_order_id", headerName: "PO no", flex: 2, minWidth: 200 },
    {
      field: "_id",
      headerName: "Purchase req ID",
      flex: 2,
      minWidth: 200,
      renderCell: (params) => (
        <table>{params.row.request_details ? Object.values(params.row.request_details).map((item, index) => <tr key={index}>{item.purchase_request_id}</tr>) : ""}</table>
      )
    },
    {
      field: "date",
      headerName: "Date",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Typography>{params.row ? formatDate(params.row.po_date) : ''}</Typography>
      )

    },
    {
      field: "bank_name",
      headerName: "Bank Name",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <table>{params.row.request_details ? Object.values(params.row.request_details).map((item, index) => <tr key={index}>{item.device_details.bank_name}</tr>) : ''}</table>
      )
    },
    {
      field: "brand",
      headerName: "Brand Name",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <table>{params.row.request_details ? Object.values(params.row.request_details).map((item, index) => <tr key={index}>{item.device_details.brand_name}</tr>) : ''}</table>
      )
    },
    {
      field: "device",
      headerName: "Device Name",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <table>{params.row.request_details ? Object.values(params.row.request_details).map((item, index) => <tr key={index}>{item.device_details.name}</tr>) : ''}</table>
      )
    },
    {
      field: "modelnumber",
      headerName: "Model No",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Typography>{params.row.request_details ? Object.values(params.row.request_details).map((item, index) => <tr key={index}>{item.device_details.model}</tr>) : ''}</Typography>
      )
    },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      minWidth: 200,
      renderCell: (params) => (
        <table>{params.row.request_details ? Object.values(params.row.request_details).map((item, index) => <tr key={index}>{item.device_details.description + ','}</tr>) : ''}</table>
      )
    },

    {
      field: "vendor",
      headerName: "Vendor's Name",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Typography>{params.row.vendor_details ? params.row.vendor_details.vendor_name : ''}</Typography>
      )
    },

    {
      field: "quantity",
      headerName: "Quantity",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => (
        <table>{params.row.request_details ? Object.values(params.row.request_details).map((item, index) => <tr key={index}>{item.quantity}</tr>) : ''}</table>
      )
    },

    {
      field: "quantity_left",
      headerName: "Quantity Left",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => (
        <table>
          {params.row.request_details ? (
            Object.values(params.row.request_details).map((item, index) => {
              const matchingDevice = params.row.device_details?.find(
                (device) => item.device_details?._id === device.device_id
              );

              console.log("matching device", matchingDevice);


              const remainingQuantity =
                params.row.remaining_quantities?.[item.device_details?._id] ??
                matchingDevice?.remaining_quantity;

              return <tr key={index}><td>{remainingQuantity ?? "N/A"}</td></tr>;
            })
          ) : null}

        </table>
      )
    },

    {
      field: "poadueamount",
      headerName: "Amount",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Typography>{params.row.total_price?params.row.total_price:CalculateAmount(params.row)?CalculateAmount(params.row):""}</Typography>
      )

    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Typography>{params.row.approval_status}</Typography>
      )
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 160,
      renderCell: (params) => (

        actionFilter !== 'Pending' ?
          <Stack gap={2}>
            <Stack direction="row" gap={1}>
              <Button
                disableFocusRipple
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => handleViewPO(params.row)}
              >
                View PO
              </Button>

            </Stack>
            <Button
              disableFocusRipple
              sx={{ display: location.pathname === "/procurement/create_payment_order" && actionFilter === "Approved" ? 'block' : 'none' }}
              variant="contained"
              color="secondary"
              disabled={
                (params.row &&
                  params.row.request_details &&
                  Object.values(params.row.request_details).some(
                    (item) => (params.row.remaining_quantities && params.row.remaining_quantities[item.device_details._id] > 0)

                  ))
                  ||
                  params.row.device_details && params.row.device_details.some((item) => item.remaining_quantity > 0)
                  ? false
                  : true
              }
              size="small"
              onClick={() => handlePurchaseOrderOpen(params.row)}
            >
              Create Payment Order
            </Button>
          </Stack>
          :
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Tooltip title="View Purchase Order Details">
              <Button
                disableFocusRipple
                variant="outlined"
                color="primary"
                size="small"
                onClick={() => handleViewPO(params.row)}
              >
                View PO
              </Button>
            </Tooltip>


          </Box>



      ),
    },
    {
      field: "remarks",
      headerName: "Remarks",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <Button
          disableFocusRipple
          variant="outlined"
          color="secondary"
          size="small"
          onClick={() => handleRemarksOpen(params.row)}
        >
          Remarks
        </Button>
      )
    },
  ];



  const handleAlertOpen = (message, type) => {
    setAlertType(type)
    setAlertMessage(message)
    setOpenAlert(true)
  }


  const handleAlertClose = () => {
    setOpenAlert(false)
  }

  useEffect(() => {
    if (UserRole) {
      GetPurchaseOrder(filters, setIsLoading, handleAlertOpen, setData, actionFilter, Page, UserRole)
      GetAllDevice(setIsLoading, setDevices, handleAlertOpen)
    }


  }, [actionFilter, UserRole, location])


  useEffect(() => {
    GetUserRole("purchase_order", setIsLoading, setUserRole, handleAlertOpen)
  }, [location])



  console.log("FilterData", filteredData,Data);


  useEffect(()=>{
      if(Data && Data.data){
        setFilterData(Data.data)
      }
  },[Data])


  // const filteredData = Data &&Data.data&&Array.isArray(Data.data) && Data.data.filter((row) => {
  //   return (

  //     (
  //       row
  //     )
  //   );
  // });

  const handleViewPO = (row) => {
    setSelectedRows(row)
    setOpen(true)
  };

  const handlePoClose = () => {
    setOpen(false)
  }

  const handleFilterChange = (key, value) => {
    console.log("key", key, "value", value, "triggered");

    setFilters((prevFilters) => ({ ...prevFilters, [key]: value }));
  };


  const handleSearch = () => {
    GetPurchaseOrder(filters, setIsLoading, handleAlertOpen, setData, actionFilter, Page, UserRole)

  }

  const resetFilters = () => {
    setFilters({
      from_date: formattedDate,
      to_date: formattedDate,
      device: ""
    });

    GetPurchaseOrder({
      from_date: formattedDate,
      to_date: formattedDate,
      device: ""
    }, setIsLoading, handleAlertOpen, setData, actionFilter, 1)

  };






  const exportToExcel = () => {

    console.log("filteredData", filteredData);
    
    const mappedData = filteredData.map(item => ({
      "PO No": item.purchase_order_id,
      "Purchase req ID": Object.values(item.request_details)
        .map(sub => sub.purchase_request_id)
        .join(", "),
      "Date": formatDate(item.po_date),
      "Brand Name": Object.values(item.request_details)
        .map(sub => sub.device_details.brand_name)
        .join(", "),
      "Device Name": Object.values(item.request_details)
        .map(sub => sub.device_details.name)
        .join(", "),
      "Model No": Object.values(item.request_details)
        .map(sub => sub.device_details.model)
        .join(", "),
      "Description": Object.values(item.request_details)
        .map(sub => sub.device_details.description)
        .join(", "),
      "Vendor's Name":item.vendor_details? item.vendor_details.vendor_name:"",
      "Quantity": Object.values(item.request_details)
        .map(sub => sub.quantity)
        .join(", "),
      "Quantity Left": item.request_details ? Object.values(item.request_details).map((sub) =>{
        let matchingDevice = item.device_details?.find((device) => sub.device_details?._id === device.device_id);
        const remainingQuantity = item.remaining_quantities?.[sub.device_details?._id] ?? matchingDevice?.remaining_quantity;
        return remainingQuantity ?? "N/A"
        //  item.remaining_quantities[sub.device_details._id]
        }).join(", ") : '',
      "Amount": item.total_price?item.total_price:CalculateAmount(item),
      "Status": item.approval_status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(mappedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Purchase Orders");
    XLSX.writeFile(workbook, "PurchaseOrders.xlsx");
  };


  return (
    <Box  sx={{ minHeight: "100vh" }}>
      <RemarksDialog data={Remarks} open={OpenRemarks} handleClose={handleRemarksClose} />
      <PaymentOrderDialog open={OpenPaymentOrder} handleClose={handleClosePurchaseOrder} data={SelectedRows} type="view" />
      <PurchaseOrderDialog ref={pdfRef} userRole={UserRole} filter={actionFilter} open={Open} handleClose={handlePoClose} data={SelectedRows} type="view" />
      <SnackBar open={OpenAlert} message={AlertMessage} type={AlertType} handleClose={handleAlertClose} />
      <BackdropLoader open={IsLoading} />
      
          {/* Enhanced Filter Section */}
          <Card variant="outlined" sx={{ padding: 2, marginBottom: 3 }}>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6} md={2} xl={2}>
                <Typography variant='h5' sx={{color:"#20415C",marginBottom:1}} fontWeight={600} >From Date</Typography>
                <TextField
                  variant="outlined"
                  type="date"
                  onKeyDown={(e) => e.preventDefault()}
                  InputLabelProps={
                    {
                      shrink: true
                    }
                  }
                  size="small"
                  value={filters.from_date}
                  inputProps={
                    {
                      max: formattedDate
                    }
                  }
                   sx={{
                    '& .MuiOutlinedInput-root': {
                      border: '2px solid #A9A9A980 50%', // change border color
                      borderRadius: '8px',
                    },
                    '& fieldset': {
                        borderColor: '#A9A9A980', 
                        borderRadius:'8px'// default border color
                    },  
                  }}
                  onChange={(e) => handleFilterChange("from_date", e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={6} md={2} xl={2}>
                <Typography variant='h5' sx={{color:"#20415C",marginBottom:1}} fontWeight={600} >To Date</Typography>
                <TextField
                  variant="outlined"
                  type="date"
                  onKeyDown={(e) => e.preventDefault()}
                  InputLabelProps={
                    {
                      shrink: true
                    }
                  }
                  inputProps={
                    {
                      max: formattedDate,
                      min: filters.from_date

                    }
                  }
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      border: '2px solid #A9A9A980 50%', // change border color
                      borderRadius: '8px',
                    },
                    '& fieldset': {
                        borderColor: '#A9A9A980', 
                        borderRadius:'8px'// default border color
                    },  
                  }}
                  size="small"
                  value={filters.to_date}
                  onChange={(e) => handleFilterChange("to_date", e.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xl={2} lg={2} xs={12} sx={{ display: 'none' }}>
                <FormControl fullWidth size='small' >
                  <InputLabel id="demo-simple-select-label">Device</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={filters.device}
                    label="Device"
                    onChange={(e) => handleFilterChange("device", e.target.value)}
                  >
                    {
                      Devices && Devices.map((item, index) => (
                        <MenuItem value={item._id} key={index}>{item.bank_name}-{item.brand_name}-{item.name}</MenuItem>
                      ))
                    }

                  </Select>
                </FormControl>
              </Grid>
              <Grid item xl={1} lg={1} xs={12} mt={3}>
                <Button sx={{
                    backgroundColor:"#688B2A",
                    color:"#fff",
                    borderRadius:"10px",
                    '&:hover': {
                      backgroundColor: "#688B3A",
                      color:"#fff",
                      borderRadius:"10px",
                    },
                    }} fullWidth size="medium" variant="contained" color="secondary" onClick={handleSearch}>
                  Search
                </Button>
              </Grid>
              <Grid item xl={1} lg={1} xs={12} mt={3}>
                <Button sx={{borderRadius:"10px"}} fullWidth size="medium" variant="contained" color="secondary" onClick={resetFilters}>
                  Clear
                </Button>
              </Grid>

            </Grid>
          </Card>

          {/* Data Grid Section */}
          <SubCard title="Purchase Orders" sx={{ marginTop: 1 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} mb={1}>
              {/* Filter Buttons */}
              <Box sx={{ display: "flex", gap: 2 }}>
                {["", "Approved", "Pending", "Rejected"].map((status) => (
                  <Button
                    key={status}
                    variant={actionFilter === status ? "contained" : "outlined"}
                    color={"secondary"}
                    sx={{borderRadius:"8px",backgroundColor:actionFilter === status ?"#592375":"inherit"}}
                    onClick={() => setActionFilter(status)}
                  >
                    {status === "" ? "All" : status}
                  </Button>
                ))}
              </Box>

              {/* Export to Excel Button */}
              <Button
                variant="outlined"
                color="primary"
                onClick={exportToExcel}
                startIcon={<FileDownloadIcon />}
              >
                Export to Excel
              </Button>
            </Box>
            <div style={{ height: 400, width: "100%" }}>
              {filteredData && filteredData.length > 0 ? (
                <DataGrid
                  loading={IsLoading}
                  rows={filteredData}
                  columns={columns(handleViewPO)}
                  initialState={{ pagination: { paginationModel: { page: Data ? Data.page : 0, pageSize: 10 } } }}
                  rowsPerPageOptions={[10]}
                  pageSize={10}
                  paginationMode="server"
                  disableSelectionOnClick
                  rowHeight={100}
                  scrollbarSize={8}
                  rowCount={Data ? Data.total_count : 10}
                  onPaginationModelChange={(pagenation) => {
                    handlePageChange(pagenation.page)
                  }}
                  getRowId={(row) => row._id}
                  components={{
                    NoRowsOverlay: () => (
                      <Box sx={{ textAlign: "center", color: "#888", padding: 2 }}>
                        <Typography variant="body1">No matching records found.</Typography>
                      </Box>
                    ),
                  }}
                  sx={{
                    "& .MuiDataGrid-root": {
                      borderRadius: "8px", // Added border radius for smoother design
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#F8FAFC",
                      color: "#592375",
                      fontWeight: "bold",
                      textTransform: "uppercase", // Text in headers becomes uppercase
                    },
                    "& .MuiDataGrid-cell": {
                      padding: "10px", // Slightly increased padding for readability
                    },
                    "& .MuiDataGrid-row:nth-of-type(odd)": {
                      backgroundColor: "#F6F6F6",
                    },
                    "& .MuiDataGrid-row:hover": {
                      backgroundColor: "#e0f7fa", // Light blue hover effect
                      cursor: "pointer",
                    },
                    "& .MuiDataGrid-footerContainer": {
                      backgroundColor: "#f8f9fa", // Light footer background for pagination
                    },
                  }}
                />
              ) : (
                <Typography variant="body1" align="center">
                  No data available.
                </Typography>
              )}
            </div>
          </SubCard>





        
      {/* Snackbar for Notifications */}

    </Box>
  );
};

export default ProcurementHeadPOpendingPage;

